import { render, staticRenderFns } from "./IconSvgAFPM2.vue?vue&type=template&id=62dbefea&scoped=true&"
import script from "./IconSvgAFPM2.vue?vue&type=script&lang=js&"
export * from "./IconSvgAFPM2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dbefea",
  null
  
)

export default component.exports